import React from 'react';
import { Translator } from 'Translator';
import useLocalSearchFilter from 'modules/locals/hooks/useLocalSearchFilters';
import useLocalSearchData from 'modules/locals/hooks/useLocalSearchData';
import { getDateFilterText } from 'modules/locals/utils/LocalSearchFilterHelper';
import useViewport from 'hooks/useViewport';
import SubNavbar from '../SubNavbar';
import FilterButton from './FilterButton';

const CSS = require('./LocalFilterSubNavbar.less');

const SCREEN_LIMIT = 992;

function getLabelForLanguages(numberOfLanguages) {
  if (numberOfLanguages === 0) {
    return Translator.translateText('LocalSearch.Filter.languages', {}, 'Languages');
  }
  if (numberOfLanguages === 1) {
    return Translator.translateText('LocalSearch.Filter.languagesWithNumber1', { nr: 1 }, '{nr} language');
  }
  return Translator.translateText('LocalSearch.Filter.languagesWithNumbers', { nr: numberOfLanguages }, '{nr} languages');
}

function LocalFilterSubNavbar() {
  const filterObject = useLocalSearchFilter();
  const { width } = useViewport();
  const show = width <= SCREEN_LIMIT;

  const isFamilyFriendlyFilterActive = filterObject.activeFilters.some(({ options }) => options.some(({ value }) => value === 'family-friendly'));
  const isDateFilterActive = filterObject.activeFilters.some(({ uid }) => uid === 'date.to' || uid === 'date.from');
  const languageFilter = filterObject.activeFilters.find(({ uid }) => uid === 'languages');
  const numberOfLanguages = languageFilter && languageFilter.options ? languageFilter.options.length : 0;
  const isLanguageFilterActive = numberOfLanguages > 0;

  const { aggregates } = useLocalSearchData(filterObject);

  if (!show) {
    return null;
  }

  return (
    <SubNavbar transparent={false}>
      <div className={CSS.SubnavbarContainer}>
        <FilterButton name="date-filter" isActive={isDateFilterActive} text={getDateFilterText(filterObject)} />
        <FilterButton name="language-filter" isActive={isLanguageFilterActive} text={getLabelForLanguages(numberOfLanguages)} />
        {aggregates && aggregates.family_friendly.buckets.some(({ key }) => key === 1) &&
          <FilterButton name="family-friendly-filter" isActive={isFamilyFriendlyFilterActive} text={Translator.translateText('LocalSearch.Filter.familyFriendly', {}, 'Family friendly')} />
        }
      </div>
    </SubNavbar>
  );
}

export default LocalFilterSubNavbar;
